// extracted by mini-css-extract-plugin
module.exports = {"Hidden":"main_Hidden__0uK5n","AdminPanel":"main_AdminPanel__P0i7r"};